import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { GoPrimitiveDot } from "react-icons/go";
import { useMutation } from "@apollo/react-hooks";
import { APP_CONTEXT } from "../../../utils/context";
import PageHeader from "../../../components/PageHeader/PageHeader.component";
import { Row, Column } from "../../../components/Grid/Grid.component";
import Form from "./ContactInformation.form.component";
import Button from "../../../components/Button/Button.component";
import Error from "../../../components/Error/ErrorMessage.component";
import BorderSelect from "../../../components/Form/BorderSelect/BorderSelect.component";
import Notification from "../../../components/Toast/Toast.component";

// GQL
import { CREATE_CONTACT_INFORMATION } from "../../../graphql/mutations/contactInformation.mutation";
import { formatGraphqlError } from "../../../utils/api";

const ContactInformationNew = () => {
  const { setActiveSideNav, setPageTitle } = useContext(APP_CONTEXT);
  const [contactInformationData, setContactInformationData] = useState({
    id: "",
    name: "",
    options: [],
    description: "",
    status: "ACTIVE",
  });
  const [createContactInformation, { loading }] = useMutation(
    CREATE_CONTACT_INFORMATION
  );

  const history = useHistory();

  useEffect(() => {
    setActiveSideNav("cm");
    setPageTitle("Create New Contact");
  });

  const {
    register,
    handleSubmit,
    errors,
    setValue,
    getValues,
    control,
  } = useForm();

  const changeStatus = (e) => {
    const tempContactInformationData = { ...contactInformationData };
    tempContactInformationData.status = e.target.value;
    setContactInformationData(tempContactInformationData);
  };

  const getColor = () => {
    switch (contactInformationData.status) {
      case "ACTIVE":
        return "#39C568";
      case "ARCHIVE":
        return "#FF003A";
      case "DRAFT":
        return "#707172";
      default:
        return "#707172";
    }
  };

  const onSubmit = (values) => {
    /**
     * Create new ContactInformation
     * push to list all contactInformations
     */

    createContactInformation({
      variables: {
        ...values,
      },
    })
      .then(() => {
        Notification.success({
          title: "Create Contact Succeeded",
          message: "",
        });
        history.push("/app/cms/contact-information");
      })
      .catch((err) =>
        Notification.error({
          title: "Create Contact Failed",
          message: formatGraphqlError(err),
        })
      );
  };

  return (
    <>
      <PageHeader title="Create New Contact" back />
      <Row>
        <Column width="70%" noPad>
          <Form
            register={register}
            errors={errors}
            contactInformationData={contactInformationData}
            setContactInformationData={setContactInformationData}
            setValue={setValue}
            getValues={getValues}
            control={control}
          />
        </Column>
        <Column width="30%">
          <BorderSelect
            header="Status"
            name="status"
            label="Please select a status"
            value={contactInformationData.status}
            register={register}
            onChange={changeStatus}
            options={[
              { value: "ACTIVE", text: "Active" },
              { value: "ARCHIVE", text: "Archive" },
              { value: "DRAFT", text: "Draft" },
            ]}
            icon={
              <GoPrimitiveDot style={{ color: getColor(), fontSize: "25px" }} />
            }
            margin="60px 0px 120px 0px"
            required={{
              required: "please enter a ContactInformation ID",
              pattern: {
                value: /^[a-zA-Z]+$/,
                message: "field cannot be empty",
              },
            }}
            error={errors.id && <Error message={errors.id.message} />}
          />

          <Button
            width="100%"
            onClick={handleSubmit(onSubmit)}
            type="button"
            kind="secondary"
            value="Create Contact Information"
            loading={loading}
          />
          <Button
            width="100%"
            onClick={() => history.goBack()}
            type="button"
            value="Cancel"
            loading={loading}
          />
        </Column>
      </Row>
    </>
  );
};

export default ContactInformationNew;
